module.exports = __webpack_public_path__ + "img/nav_icon_scope.b4c02d63.svg";